import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const navGroups = [
  {
    label: 'Produção',
    items: [
      { path: '/dashboard', icon: 'ri-dashboard-line', label: 'Dashboard', exact: true },
      { path: '/content', icon: 'ri-file-text-line', label: 'Gestão de Conteúdo' },
      { path: '/ai-processing', icon: 'ri-robot-line', label: 'Processamento IA' },
    ],
  },
  {
    label: 'Editorial',
    items: [
      { path: '/editor', icon: 'ri-edit-box-line', label: 'Editor de Páginas' },
      { path: '/layout-engine', icon: 'ri-layout-grid-line', label: 'Motor de Layout' },
      { path: '/export', icon: 'ri-export-line', label: 'Exportar & Distribuir' },
    ],
  },
  {
    label: 'Sistema',
    items: [
      { path: '/settings', icon: 'ri-settings-3-line', label: 'Configurações' },
      { path: '/', icon: 'ri-global-line', label: 'Ver Landing Page', exact: true },
    ],
  },
];

export default function Sidebar() {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  return (
    <aside
      className={`flex flex-col h-screen bg-white border-r border-[#E0E0E0] transition-all duration-300 ${collapsed ? 'w-14' : 'w-56'} flex-shrink-0`}
    >
      {/* Logo / Masthead */}
      <div className={`border-b-2 border-[#111111] ${collapsed ? 'px-2 py-4' : 'px-4 py-4'}`}>
        {!collapsed ? (
          <div className="text-center">
            <div className="flex items-center justify-center gap-2 mb-1">
              <img
                src="https://static.readdy.ai/image/cb3f25066178f57a7b4ff6ec1e98d674/3adf4e78d4ccc80f9408185bfae7ead8.png"
                alt="Jardel City Post"
                className="w-7 h-7 object-contain"
              />
              <p className="font-blackletter text-[#111111] text-lg leading-none tracking-wide">
                Jardel City Post
              </p>
            </div>
            <div className="flex items-center gap-1 justify-center mt-1">
              <div className="flex-1 h-px bg-[#111111]"></div>
              <p className="text-[9px] font-sans font-semibold tracking-[0.15em] uppercase text-[#666666] px-1">
                Sistema Editorial
              </p>
              <div className="flex-1 h-px bg-[#111111]"></div>
            </div>
          </div>
        ) : (
          <div className="flex justify-center">
            <img
              src="https://static.readdy.ai/image/cb3f25066178f57a7b4ff6ec1e98d674/3adf4e78d4ccc80f9408185bfae7ead8.png"
              alt="JCP"
              className="w-7 h-7 object-contain"
            />
          </div>
        )}
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="mt-2 w-full flex items-center justify-center text-[#999999] hover:text-[#111111] transition-colors cursor-pointer"
        >
          <i className={`${collapsed ? 'ri-menu-unfold-line' : 'ri-menu-fold-line'} text-sm`}></i>
        </button>
      </div>

      {/* User */}
      <div className={`flex items-center gap-2.5 border-b border-[#E0E0E0] ${collapsed ? 'px-2 py-3 justify-center' : 'px-4 py-3'}`}>
        <div className="w-7 h-7 rounded-full bg-[#111111] flex items-center justify-center flex-shrink-0">
          <span className="text-[10px] font-bold text-white">JE</span>
        </div>
        {!collapsed && (
          <div className="overflow-hidden">
            <p className="text-xs font-semibold text-[#111111] truncate font-sans">João Editor</p>
            <p className="text-[10px] text-[#999999] font-sans">Editor-Chefe</p>
          </div>
        )}
      </div>

      {/* Nav */}
      <nav className="flex-1 overflow-y-auto py-3 px-2">
        {navGroups.map((group) => (
          <div key={group.label} className="mb-3">
            {!collapsed && (
              <p className="text-[9px] font-bold text-[#999999] uppercase tracking-[0.12em] px-2 mb-1 font-sans">
                {group.label}
              </p>
            )}
            {group.items.map((item) => {
              const isActive = item.exact
                ? location.pathname === item.path
                : location.pathname.startsWith(item.path) && item.path !== '/';

              return (
                <NavLink
                  key={item.path}
                  to={item.path}
                  title={collapsed ? item.label : undefined}
                  className={`flex items-center gap-2.5 px-2 py-2 rounded transition-all duration-100 cursor-pointer mb-0.5 group ${
                    isActive
                      ? 'bg-[#111111] text-white'
                      : 'text-[#444444] hover:bg-[#F0F0F0] hover:text-[#111111]'
                  } ${collapsed ? 'justify-center' : ''}`}
                >
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-sm`}></i>
                  </div>
                  {!collapsed && (
                    <span className="text-xs font-medium font-sans truncate">{item.label}</span>
                  )}
                  {isActive && !collapsed && (
                    <div className="ml-auto w-1 h-1 rounded-full bg-[#C41230]"></div>
                  )}
                </NavLink>
              );
            })}
            {!collapsed && <div className="mt-2 border-t border-[#E0E0E0]"></div>}
          </div>
        ))}
      </nav>

      {/* Footer */}
      <div className={`border-t border-[#E0E0E0] ${collapsed ? 'px-2 py-3 text-center' : 'px-4 py-3'}`}>
        {!collapsed ? (
          <div>
            <p className="text-[9px] text-[#999999] font-sans">Jardel City Post © 2026</p>
            <p className="text-[9px] text-[#C8C8C8] font-sans">40 anos de jornalismo</p>
          </div>
        ) : (
          <div className="w-4 h-4 flex items-center justify-center mx-auto">
            <i className="ri-information-line text-[#C8C8C8] text-xs"></i>
          </div>
        )}
      </div>
    </aside>
  );
}
